import { firestoreHttpsCallable } from './util'

export const stafferAccountDeny = async (stafferId: string) =>
  firestoreHttpsCallable('stafferAccountDeny', { stafferId })
